import React, { useState } from 'react';
import { ListaCotizacionesPostventaCV } from './listaCotizacionesPostventaCV';
import { CrearCotizacionPostventaCV } from './crearCotizacionPostventaCV';
import { generarIdTemporal } from '../../../globales/componentes/tabla/useEdicionFilas';
import type { ICotizacionPostventa, ICotizacionPostventaResumen } from '../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';
import { useNotificaciones } from '../../../globales/contextos/notificationContext';
import { EnumTipoNotificacion } from '../../../globales/interfaces';

/** Fila del listado a partir de una cotización completa. */
const resumirCotizacion = (c: ICotizacionPostventa): ICotizacionPostventaResumen => ({
    Id: c.Id as string,
    Proyecto: c.Proyecto,
    Cliente: c.Cliente,
    Descripcion: c.Descripcion,
    NumeroUnidades: c.NumeroUnidades,
    PrecioVentaTotal: c.Resultado?.PrecioVentaTotal ?? 0,
    Estado: c.Estado,
    FechaCreacion: c.FechaCreacion ?? new Date().toISOString(),
    UsuarioCreadorNombre: c.UsuarioCreadorNombre
});

/** Alterna entre el listado y el formulario de la cotización postventa. */
export const CotizadorPostventaCV: React.FC = () => {
    const { mostrarNotificacion } = useNotificaciones();
    const [vistaActiva, setVistaActiva] = useState<'lista' | 'crear'>('lista');
    const [cotizacionAEditar, setCotizacionAEditar] = useState<ICotizacionPostventa | undefined>();
    // TODO back: listar, consultar, guardar y eliminar en el servicio del cotizador. Mientras tanto, en memoria.
    const [cotizaciones, setCotizaciones] = useState<ICotizacionPostventa[]>([]);

    const abrirFormulario = (cotizacion?: ICotizacionPostventa) => {
        setCotizacionAEditar(cotizacion);
        setVistaActiva('crear');
    };

    const volverAlListado = () => {
        setCotizacionAEditar(undefined);
        setVistaActiva('lista');
    };

    const guardar = (cotizacion: ICotizacionPostventa) => {
        const guardada = { ...cotizacion, Id: cotizacion.Id ?? generarIdTemporal() };
        setCotizaciones(prev => prev.some(c => c.Id === guardada.Id)
            ? prev.map(c => c.Id === guardada.Id ? guardada : c)
            : [guardada, ...prev]);
        mostrarNotificacion(EnumTipoNotificacion.Success, 'Cotización guardada', `La cotización de ${guardada.Proyecto} quedó guardada.`, 3000);
        volverAlListado();
    };

    if (vistaActiva === 'crear') {
        return <CrearCotizacionPostventaCV cotizacionInicial={cotizacionAEditar} alGuardar={guardar} alVolver={volverAlListado} />;
    }

    return (
        <ListaCotizacionesPostventaCV
            cotizaciones={cotizaciones.map(resumirCotizacion)}
            alCrearNueva={() => abrirFormulario()}
            alEditar={(id) => abrirFormulario(cotizaciones.find(c => c.Id === id))}
            alEliminar={(id) => setCotizaciones(prev => prev.filter(c => c.Id !== id))}
            alRefrescar={() => { /* TODO back: volver a consultar el listado. */ }}
        />
    );
};
